import { ComponentIds, Entity } from '@inter-ikea-core/core';
import { CommunicationSizeComponent } from '@inter-ikea-core/core';
import { Product, ProductInfoComponent, ProductType } from '@inter-ikea-storageone/range';

const getEntitySizeString = (entity: Entity) => {
  const entitySize = entity.getComponent<CommunicationSizeComponent>(
    ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID
  )?.size;
  return entitySize ? `${entitySize.width}x${entitySize.depth}` : null;
};

const getEnitiesWithProductType = (entities: Entity[], productType: ProductType) => {
  return entities.filter(
    entity =>
      entity.getComponent<ProductInfoComponent>(ProductInfoComponent.id)?.productType ===
      productType
  );
};

export const matchInteriorsToSections = (products: Product[], entitiesInScene: Entity[]) => {
  const sectionsInScene = getEnitiesWithProductType(entitiesInScene, ProductType.IVAR_SECTION);
  const cornerSectionsInScene = getEnitiesWithProductType(
    entitiesInScene,
    ProductType.IVAR_CORNER_SECTION
  );
  const cornerSectionSizesInScene = cornerSectionsInScene
    .map(section => getEntitySizeString(section))
    .filter(Boolean) as string[];
  if ([...sectionsInScene, ...cornerSectionsInScene].length === 0) return products;
  const pineShelvesInScene = getEnitiesWithProductType(
    entitiesInScene,
    ProductType.IVAR_SHELF_PINE
  );
  const sectionSizesInScene = sectionsInScene
    .map(section => getEntitySizeString(section))
    .filter(Boolean) as string[];
  const shelfSizesInScene = pineShelvesInScene.map(shelf => getEntitySizeString(shelf));

  return products.filter(product => {
    const interiorSize = `${product.communicatedDimensions.width}x${product.communicatedDimensions.depth}`;
    if (
      [
        ProductType.IVAR_SHELF_PINE,
        ProductType.IVAR_SHELF_FELT,
        ProductType.IVAR_SHELF_METAL,
        ProductType.IVAR_DRAWER_PINE,
        ProductType.IVAR_BOTTLE_RACK,
        ProductType.IVAR_TABLE
      ].includes(product.type)
    ) {
      return sectionSizesInScene.includes(interiorSize);
    } else if (product.type === ProductType.IVAR_DRAWER_METAL) {
      return pineShelvesInScene.length > 0;
    } else if (product.type === ProductType.IVAR_CLOTHES_RAIL) {
      return shelfSizesInScene.includes(interiorSize);
    } else if (product.type === ProductType.IVAR_CORNER_SHELF) {
      return cornerSectionSizesInScene.includes(interiorSize);
    }
    return true;
  });
};
